/* Phone menu: the second-level panels slide in over the root list and slide
   back with the arrow. Panels reset whenever the drawer closes. */
(function () {
  var drawer = document.getElementById('mobile-nav-drawer');
  if (!drawer) return;
  function closePanel(panel) {
    panel.classList.remove('is-open');
    var opener = drawer.querySelector('[data-mobile-open="' + panel.id + '"]');
    if (opener) opener.setAttribute('aria-expanded', 'false');
    return opener;
  }
  drawer.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-mobile-open]');
    if (opener) {
      var panel = document.getElementById(opener.getAttribute('data-mobile-open'));
      if (!panel) return;
      panel.classList.add('is-open');
      opener.setAttribute('aria-expanded', 'true');
      var back = panel.querySelector('[data-mobile-back]');
      if (back) back.focus({ preventScroll: true });
      return;
    }
    var back = event.target.closest('[data-mobile-back]');
    if (back) {
      var panel = back.closest('.mobile-drawer__panel--sub');
      if (!panel) return;
      var from = closePanel(panel);
      if (from) from.focus({ preventScroll: true });
    }
  });
  if ('MutationObserver' in window) {
    new MutationObserver(function () {
      if (drawer.getAttribute('aria-hidden') === 'true') {
        drawer.querySelectorAll('.mobile-drawer__panel--sub.is-open').forEach(closePanel);
      }
    }).observe(drawer, { attributes: true, attributeFilter: ['aria-hidden'] });
  }
})();
